import { TextField } from '@mui/material';
import { useRef, useEffect } from 'react';

interface TextEditorProps {
    ruleId: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

function TextEditor({ ruleId, value, onChange, placeholder }: TextEditorProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    // Mettre à jour la valeur initiale si elle change (ex: lors du chargement d'une query sauvegardée)
    useEffect(() => {
        if (inputRef.current && inputRef.current.value !== value) {
            inputRef.current.value = value || '';
        }
    }, [value]);

    return (
        <TextField
            inputRef={inputRef}
            type="text"
            size="small"
            fullWidth
            defaultValue={value || ''}
            onBlur={(e) => onChange(e.target.value)}
            placeholder={placeholder || 'Entrez une valeur...'}
        />
    );
};

export default TextEditor;
